import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['change'];

  connect() {
    this.changeTarget.addEventListener('change', this.onChange.bind(this));
  }

  onChange() {
    this.element.submit();
  }
}
